import { ResponseBody } from './api.model';

export enum AppErrorType {
  VALIDATION,
  LOGICAL,
  OUT_OF_SCOPE,
  UNKNOWN
}
export interface AppError<Data> extends Error {
  data: Data;
  errorType: AppErrorType;
  statusCode: number;
  rawResponse: ResponseBody<Data>;
}

